import { render, staticRenderFns } from "./YourPro.vue?vue&type=template&id=5a637310&"
import script from "./YourPro.vue?vue&type=script&lang=js&"
export * from "./YourPro.vue?vue&type=script&lang=js&"
import style0 from "./YourPro.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports